<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Employees’ Experience, years
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <h3>Headers to show:</h3>
              <div
                class="px-2 d-inline-block"
                v-for="entry in visibleHeadersToShow"
                :key="entry.originalIndex"
              >
                <v-switch
                  dense
                  v-if="entry.head"
                  :label="entry.head.categoryName"
                  v-model="headersToShow[entry.originalIndex].show"></v-switch>
              </div>
              <v-divider></v-divider>
              <v-data-table
                dense
                class="data-table"
                mobile-breakpoint="0"
                fixed-header
                :height="tableHeight"
                :headers="orderedHeader"
                :items="sortedSkills"
                :loading="loadingSkillsList"
                loading-text="Loading skills..."
                :items-per-page="50"
                :search="search"
                :footer-props="{
                  'items-per-page-options': [10, 30, 50, -1]
                }"
                @update:page="goTo"
                @update:options="onSort"
              >
                <template v-slot:[`header`]>
                  <thead class="v-data-table-header">
                    <tr>
                      <th
                        v-for="(gr, grKey) in tableGroups"
                        :key="grKey"
                        class="px-2 text-no-wrap text-center"
                        :colspan="gr.length"
                      >
                        {{ gr.categoryName }}
                      </th>
                    </tr>
                  </thead>
                </template>
                <template
                  v-for="(itm, itmKey) in orderedHeader"
                  v-slot:[`item.${itm.value}`]="{ item }"
                >
                  <!-- {{itm.value}} -->
                  <span
                    :key="itmKey"
                    class='editable-cell'
                    v-if="itm.value === 'English_Level'"
                    @click="editEnglishLevel(item[`${itm.value}`], item.Employee_ID, itm.categoryId)"
                  >
                    {{ item[`${itm.value}`] }}
                  </span>
                  <span
                    :key="itmKey + 'Full_Name'"
                    v-else-if="itm.value === 'Full_Name'"
                    @click="openSkillsEditorDialog(item.Employee_ID, item.Full_Name)"
                  >
                    {{ item[`${itm.value}`] }}
                  </span>
                  <span
                    v-else-if="item[`${itm.value}`] && item[`${itm.value}`].isPrimary"
                    class="editable-cell font-weight-black"
                    :key="itmKey + 'Is_Primary'"
                    @click.stop="onCellClick(item[`${itm.value}`], item.Full_Name, itm.text)"
                  >
                    {{ showFormatedValue(item[`${itm.value}`]) }}
                  </span>
                  <span
                    v-else
                    class="editable-cell"
                    :key="itmKey + 'Rest'"
                    @click.stop="handleCellClick(item, itm, item.Full_Name, itm.text)"
                  >
                    {{ showFormatedValue(item[`${itm.value}`]) }}
                  </span>
                </template>
                 <template v-slot:[`footer`]>
                  <v-row class="py-2">
                    <v-spacer></v-spacer>
                    <v-col cols="auto" v-if="canManageEmployees">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="warning"
                            small
                            outlined
                            @click.prevent="triggerSkillsFileInput"
                            class="mr-2"
                            :disabled="loadingSkills"
                            :loading="loadingSkills"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon small left v-if="!loadingSkills">mdi-file-upload</v-icon>
                            <v-progress-circular
                              v-else
                              indeterminate
                              color="white"
                              size="16"
                              width="2"
                              class="mr-1"
                            ></v-progress-circular>
                            Upload Skills
                          </v-btn>
                        </template>
                        <span>Upload Excel file with employee skills. Processing may take several minutes for large files.</span>
                      </v-tooltip>
                      <input
                        type="file"
                        ref="skillsFileInput"
                        accept=".xlsx, .xls"
                        style="display: none;"
                        @change="uploadSkillsFile"
                      />
                      <v-btn
                        v-if="canManageEmployees"
                        color="primary"
                        small
                        outlined
                        @click.prevent="exportToXLSX"
                      >
                        <v-icon small left>mdi-file-download</v-icon>
                        Export to XLSX
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="showEnglishLevelEditDialog"
      max-width="500px"
      @click:outside="closeDialog"
      @keydown.esc="closeDialog"
    >
      <v-card>
        <v-card-title>
          Edit English Level
          <v-spacer></v-spacer>
          <v-btn
            icon
            blur
            @click.prevent="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-select
            label="English Level"
            :items="englishLevels"
            item-text="Dev_Skills_Subcategory_Description"
            item-value="Dev_Skills_Subcategory_ID"
            v-model="currentEnglishLevelEdit.subcategoryId"
            hide-detals
          ></v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click="saveEnglishLevel" :disabled="saveEnglishLevelDisable">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showEditDialog"
      max-width="500px"
      @click:outside="closeDialog"
      @keydown.esc="closeDialog"
    >
      <v-card>
        <v-card-title>
          {{`Edit ${currentValueToEdit.employeeFullName}’s ${currentValueToEdit.subCategoryName} skill`}}
          <v-spacer></v-spacer>
          <v-btn
            icon
            blur
            @click.prevent="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-textarea
            v-if="isTextField"
            label="Additional Information"
            v-model="currentValueToEdit.textValue"
            rows="3"
            hide-detals
          ></v-textarea>
          <template v-else>
            <v-text-field
              label="Years of experience"
              v-model="currentValueToEdit.years"
              hide-detals
            ></v-text-field>
            <v-text-field
              label="Year when finished work"
              v-model="currentValueToEdit.endYear"
              :rules="[rules.year]"
              hide-detals
            ></v-text-field>
          </template>
          <template v-if="!isTextField">
            <v-row>
              <v-col cols="12" md="6" lg="6">
                <v-select
                  v-model="currentValueToEdit.your_estimation"
                  :items=[1,2,3,4,5]
                  label="Your Estimation"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <DatePicker
                  v-model="currentValueToEdit.date_of_estimation"
                  label="Date of Estimation"
                  clearable
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="6">
                <v-select
                  v-if="!showExpert"
                  v-model="currentValueToEdit.expertId"
                  :items="employeeList"
                  label="Expert"
                  item-text="full_name"
                  item-value="employee_id"
                  :disabled="cantSetExpertEstimation"
                >
                  <template v-slot:prepend-item>
                    <div class="px-2">
                      <v-text-field
                        label="Search employee"
                        v-model="searchEmployee"
                      ></v-text-field>
                    </div>
                  </template>
                </v-select>
                <v-text-field
                  v-else
                  label="Expert"
                  v-model="currentValueToEdit.expert_full_name"
                  :disabled="cantSetExpertEstimation"
                  hide-detals
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <v-select
                  v-model="currentValueToEdit.expert_estimation"
                  :items=[1,2,3,4,5]
                  label="Expert Estimation"
                  :disabled="cantSetExpertEstimation"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-checkbox
                v-model="currentValueToEdit.isPrimary"
                label="Primary Skill"
                class="ml-3"
              >
              </v-checkbox>
              <v-spacer></v-spacer>
              <v-switch
                v-model="showExpert"
                class="mr-2"
                color="primary"
                label="Expert from other side"
                hide-details
                :disabled="cantSetExpertEstimation"
              >
              </v-switch>
            </v-row>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" :disabled="!validYear || saveSkillsDisable" @click="saveSkills">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <EmployeeSkillsProfile
      v-if="showEmployeeSkillsDialog"
      v-model="showEmployeeSkillsDialog"
      :employee="editedEmployee"
    />
    <v-dialog
      v-model="showYearSelectDialog"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          Select Year
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="cancelYearSelect"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p class="mb-4">Please select the year for the skills file:</p>
          <v-text-field
            v-model.number="selectedYear"
            label="Year"
            type="number"
            :rules="[rules.year]"
            min="2000"
            :max="new Date().getFullYear()"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small @click="cancelYearSelect">Cancel</v-btn>
          <v-btn small color="primary" @click="confirmYearSelect" :disabled="!selectedYear || selectedYear < 2000 || selectedYear > new Date().getFullYear()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
const xlsx = require('json-as-xlsx')

export default {
  name: 'EmployeeSkills',
  components: {
    DatePicker: () => import('@/components/global/DatePicker.vue'),
    EmployeeSkillsProfile: () => import('@/components/employee_skills/EmployeeSkillsProfile.vue')
  },
  data () {
    return {
      saveEnglishLevelDisable: false,
      saveSkillsDisable: false,
      search: '',
      skills: [],
      headers: [],
      showEditDialog: false,
      showCategorySkillsEditor: false,
      englishLevels: [],
      headersToShow: [],
      isHR: false,
      sortBy: {
        key: '',
        desc: false
      },
      showEnglishLevelEditDialog: false,
      currentEnglishLevelEdit: {
        employeeId: null,
        categoryId: null,
        englishLevel: null
      },
      currentValueToEdit: {
        employeeId: null,
        employeeFullName: '',
        skillsId: null,
        subcategoryId: null,
        categoryId: null,
        subCategoryName: '',
        years: null,
        endYear: null,
        your_estimation: null,
        date_of_estimation: null,
        expertId: null,
        expert_full_name: '',
        expert_estimation: null,
        isPrimary: false,
        textValue: null
      },
      isTextField: false,
      loadingSkills: false,
      loadingSkillsList: false,
      orderHeadersByCategoryIDs: [],
      searchEmployee: '',
      isEmployee: false,
      rules: {
        year: v => ((v >= 2000 && v <= new Date().getFullYear()) || !v) || `enter year from 2000 to ${new Date().getFullYear()}`
      },
      editMode: false,
      editedEmployee: {
        employeeId: null,
        employeeFullName: null
      },
      showYearSelectDialog: false,
      selectedYear: new Date().getFullYear(),
      pendingFile: null
    }
  },
  computed: {
    sortedSkills () {
      const res = Object.assign([], this.skills)
      if (this.sortBy.key) {
        if (['Full_Name', 'English_Level'].indexOf(this.sortBy.key) === -1) {
          res.sort((a, b) => {
            if (a[this.sortBy.key].years < b[this.sortBy.key].years) return -1
            if (a[this.sortBy.key].years > b[this.sortBy.key].years) return 1
            return 0
          })
        }
        if (this.sortBy.desc) res.reverse()
      }
      return res
    },
    tableHeight () {
      const windowW = window.innerWidth
      return windowW < 768 ? 'calc(100vh - 280px)' : 'calc(100vh - 290px)'
    },
    tableGroups () {
      const res = []
      if (this.orderedHeader.length) {
        for (let i = 0; i < this.orderedHeader.length; i++) {
          if (res.findIndex(item => item.categoryId === this.orderedHeader[i].categoryId) === -1) {
            res.push({
              categoryId: this.orderedHeader[i].categoryId,
              categoryName: this.orderedHeader[i].categoryDescr,
              length: this.orderedHeader.filter(item => item.categoryId === this.orderedHeader[i].categoryId).length
            })
          }
        }
      }
      return res
    },
    orderedHeader () {
      let res = []
      if (this.headers.length) {
        this.orderHeadersByCategoryIDs.forEach(item => {
          this.headers.filter(h => h.categoryId === item).forEach(oh => {
            let toShow = true
            if (this.headersToShow.length && oh.categoryDescr) {
              toShow = this.headersToShow.filter(h => h.categoryId === oh.categoryId)[0].show
            }
            if (toShow && (oh.categoryDescr || '').toLowerCase() === 'additional information' && !this.canManageEmployees) {
              toShow = false
            }
            if (toShow) {
              res.push(oh)
            }
          })
        })
      } else {
        res = this.headers
      }
      res.forEach((item, index) => {
        let colorClass = ''
        if (item.categoryId > 0) {
          colorClass = this.$vuetify.theme.dark ? 'green darken-4' : 'light-green lighten-4'
          if (item.categoryId % 2 === 0) colorClass = this.$vuetify.theme.dark ? 'indigo' : 'indigo lighten-4'
          if (item.categoryId % 3 === 0) colorClass = this.$vuetify.theme.dark ? 'yellow darken-4' : 'yellow lighten-4'
          if (item.categoryId % 4 === 0) colorClass = this.$vuetify.theme.dark ? 'deep-purple' : 'deep-purple lighten-4'
          if (item.categoryId % 5 === 0) colorClass = this.$vuetify.theme.dark ? 'blue-grey' : 'blue-grey lighten-4'
          if (item.categoryId % 6 === 0) colorClass = this.$vuetify.theme.dark ? 'orange' : 'orange lighten-4'
        }
        if (index < res.length) item.divider = true
        item.class = index === 0 ? `px-2 text-no-wrap fixed-column ${colorClass}` : `px-2 text-no-wrap ${colorClass}`
        item.cellClass = index === 0 ? 'px-2 text-no-wrap fixed-column' : `px-2 text-no-wrap ${colorClass}`
      })
      return res
    },
    user () {
      return this.$store.getters.getUser
    },
    employeeList () {
      const r = new RegExp(this.searchEmployee, 'gi')
      return this.$store.getters.getEmployee.filter(item => {
        r.lastIndex = 0
        return r.test(item.full_name)
      })
    },
    showExpert: {
      get () {
        let res = this.isEmployee
        if (!this.currentValueToEdit.expertId && this.currentValueToEdit.expert_full_name) {
          res = true
        }
        return res
      },
      set (val) {
        this.isEmployee = val
      }
    },
    cantSetExpertEstimation () {
      let res = true
      if (this.currentValueToEdit.expertId === this.user.employee_id || this.isHR) {
        res = false
      } else {
        res = true
      }
      return res
    },
    validYear () {
      let res = false
      if ((this.currentValueToEdit.endYear >= 2000 && this.currentValueToEdit.endYear <= new Date().getFullYear()) || !this.currentValueToEdit.endYear) {
        res = true
      } else {
        res = false
      }
      return res
    },
    showEmployeeSkillsDialog: {
      get () {
        return this.showCategorySkillsEditor
      },
      set (val) {
        if (!val) {
          this.getSkills()
        }
        this.showCategorySkillsEditor = val
      }
    },
    employeeRoles () {
      return this.$store.getters.getEmployeeRoles
    },
    canManageEmployees () {
      if (!this.employeeRoles) {
        return false
      }
      return this.employeeRoles.manager?.val ||
             this.employeeRoles.hr?.val ||
             this.employeeRoles.financier?.val
    },
    visibleHeadersToShow () {
      return this.headersToShow
        .map((head, i) => ({ head, originalIndex: i }))
        .filter(entry =>
          this.canManageEmployees ||
          (entry.head.categoryName || '').toLowerCase() !== 'additional information'
        )
    }
  },
  mounted () {
    this.getRoles()
    this.getSkills()
    if (!this.employeeList.length) {
      this.getEmployeeList()
    }
    if (this.$route.params.Full_Name) {
      this.search = this.$route.params.Full_Name
      this.continueGettingSkillsFromEmployee()
    }
  },
  methods: {
    getRoles () {
      this.axios.get('/api/employee_role/' + this.user.login, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.isHR = result.data.findIndex(item => item.RoleName === 'HR') > -1
        this.$store.dispatch('setEmployeeRoles', { roles: result.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getEmployeeList () {
      this.axios.get('/api/employeelist', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setEmployeeList', { employeeList: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    exportToXLSX () {
      const columns = this.orderedHeader.map(h => ({
        label: h.text,
        value: h.value
      }))

      const content = this.sortedSkills.map(skill => {
        const item = {}
        columns.forEach(col => {
          const val = skill[col.value]
          if (typeof val === 'object' && val !== null && 'years' in val) {
            item[col.value] = val.years
          } else {
            item[col.value] = val
          }
        })
        return item
      })

      const data = [
        {
          sheet: 'Employee Skills',
          columns: columns,
          content: content
        }
      ]

      xlsx(data, {
        fileName: 'Employee_Skills_Report'
      })
    },

    onSort (e) {
      this.sortBy.key = e.sortBy[0]
      this.sortBy.desc = e.sortDesc[0]
    },
    saveSkills () {
      this.saveSkillsDisable = true

      if (this.isTextField) {
        const additionalInfoData = {
          employeeId: this.currentValueToEdit.employeeId,
          subcategoryId: this.currentValueToEdit.subcategoryId,
          textValue: this.currentValueToEdit.textValue || ''
        }
        this.axios.post('/api/employee_skills/additional_info', additionalInfoData, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.saveSkillsDisable = false
          this.showEditDialog = false
          this.$store.dispatch('setSuccess', { successMsg: 'Additional information successfully saved' })
          this.getSkills()
        }).catch(error => {
          this.saveSkillsDisable = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
        return
      }

      if (this.showExpert) {
        this.currentValueToEdit.expertId = null
      } else if (this.currentValueToEdit.expertId) {
        this.currentValueToEdit.expert_full_name = this.employeeList.filter(item => item.employee_id === this.currentValueToEdit.expertId)[0].full_name
      }
      if (this.currentValueToEdit.skillsId) {
        this.axios.put('/api/employee_skills', this.currentValueToEdit, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.saveSkillsDisable = false
          this.closeDialog()
          this.$store.dispatch('setSuccess', { successMsg: 'Skills successfuly updated' })
          this.getSkills()
        }).catch(error => {
          this.saveSkillsDisable = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.axios.post('/api/employee_skills', this.currentValueToEdit, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.saveSkillsDisable = false
          this.currentValueToEdit.skillsId = res.data[0].Dev_Skills_ID
          this.closeDialog()
          this.$store.dispatch('setSuccess', { successMsg: 'Skills successfuly saved' })
          this.getSkills()
        }).catch(error => {
          this.saveSkillsDisable = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    },
    saveEnglishLevel () {
      this.saveEnglishLevelDisable = true
      this.currentEnglishLevelEdit.englishLevel =
        this.englishLevels.filter(item => {
          return item.Dev_Skills_Subcategory_ID === this.currentEnglishLevelEdit.subcategoryId
        })[0].Dev_Skills_Subcategory_Description
      this.axios.post('/api/employee_english_skills', this.currentEnglishLevelEdit, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.saveEnglishLevelDisable = false
        const ind = this.skills.findIndex(item => item.Employee_ID === res.data[0].Employee_ID)
        this.skills[ind].English_Level = res.data[0].Dev_Skills_English_Level
        this.$store.dispatch('setSuccess', { successMsg: 'English level successfuly saved' })
        this.closeDialog()
      }).catch(error => {
        this.saveEnglishLevelDisable = false
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    showFormatedValue (val) {
      if (!val) return ''
      if (val.textValue !== undefined && val.textValue !== null) {
        return val.textValue
      }
      let res = ''
      if (val.years) res = val.years
      if (val.endYear) res += `(${val.endYear})`
      return res
    },
    handleCellClick (item, itm, fullName, subcategoryName) {
      const val = item[itm.value]

      const canEdit = item.Employee_ID === this.user.employee_id || this.isHR
      if (!canEdit) {
        return
      }

      const actualSubcategoryName = subcategoryName || itm.text || 'Skill'

      const additionalInfoSubcategories = ['unit', 'date of filling', 'seniority', 'primary role', 'primary skills', 'can be tech lead', 'ext rate', 'int rate']
      const subcategoryNameLower = (actualSubcategoryName || '').toLowerCase().trim()
      const isAdditionalInfoSubcategory = additionalInfoSubcategories.includes(subcategoryNameLower)

      if (!val) {
        if (isAdditionalInfoSubcategory) {
          this.currentValueToEdit = {
            employeeId: item.Employee_ID,
            employeeFullName: fullName,
            skillsId: null,
            subcategoryId: itm.subcategoryId,
            categoryId: itm.categoryId,
            subCategoryName: actualSubcategoryName,
            textValue: ''
          }
          this.isTextField = true
        } else {
          this.currentValueToEdit = {
            employeeId: item.Employee_ID,
            employeeFullName: fullName,
            skillsId: null,
            subcategoryId: itm.subcategoryId,
            categoryId: itm.categoryId,
            subCategoryName: actualSubcategoryName,
            years: null,
            endYear: null,
            your_estimation: null,
            date_of_estimation: null,
            expertId: null,
            expert_full_name: '',
            expert_estimation: null,
            isPrimary: false
          }
          this.isTextField = false
        }
        this.showEditDialog = true
        return
      }

      this.onCellClick(val, fullName, actualSubcategoryName)
    },
    editEnglishLevel (currentValue, employeeId, categoryId) {
      if (employeeId === this.user.employee_id || this.isHR) {
        if (currentValue) {
          this.currentEnglishLevelEdit.subcategoryId =
          this.englishLevels.filter(item => item.Dev_Skills_Subcategory_Description === currentValue)[0].Dev_Skills_Subcategory_ID
        }
        this.currentEnglishLevelEdit.employeeId = employeeId
        this.currentEnglishLevelEdit.categoryId = categoryId
        this.currentEnglishLevelEdit.englishLevel = currentValue
        this.showEnglishLevelEditDialog = true
      }
    },
    onCellClick (val, fullName, subcategoryName) {
      if (!val) return
      if (val.employeeId === this.user.employee_id || this.isHR || val.expertId === this.user.employee_id) {
        const additionalInfoSubcategories = ['unit', 'date of filling', 'seniority', 'primary role', 'primary skills', 'can be tech lead', 'ext rate', 'int rate']
        const subcategoryNameLower = (subcategoryName || '').toLowerCase().trim()
        const isAdditionalInfoSubcategory = additionalInfoSubcategories.includes(subcategoryNameLower)

        if (val.textValue !== undefined || isAdditionalInfoSubcategory) {
          this.isTextField = true
          this.currentValueToEdit = {
            ...val,
            employeeFullName: fullName,
            subCategoryName: subcategoryName,
            textValue: val.textValue || ''
          }
        } else {
          this.isTextField = false
          this.currentValueToEdit = {
            ...val,
            employeeFullName: fullName,
            subCategoryName: subcategoryName
          }
        }
        this.showEditDialog = true
      }
    },
    openSkillsEditorDialog (employeeId, fullName) {
      if (this.isHR) {
        this.editedEmployee.employeeId = employeeId
        this.editedEmployee.employeeFullName = fullName
        this.showEmployeeSkillsDialog = true
      }
    },
    getSkills () {
      this.loadingSkillsList = true
      this.axios.get('/api/employee_skills', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.headers = res.data[0]
        this.skills = res.data[1]
        this.englishLevels = res.data[2]
        this.orderHeadersByCategoryIDs = res.data[3]
        this.headers.forEach(item => {
          if (item.categoryDescr) {
            if (this.headersToShow.findIndex(h => h.categoryId === item.categoryId) === -1) {
              this.headersToShow.push({
                show: true,
                categoryName: item.categoryDescr,
                categoryId: item.categoryId
              })
            }
          }
        })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      }).finally(() => {
        this.loadingSkillsList = false
      })
    },
    goTo () {
      this.$vuetify.goTo(
        '.data-table tbody tr',
        {
          offset: 50,
          container: '.v-data-table__wrapper'
        }
      )
    },
    continueGettingSkillsFromEmployee () {
      setTimeout(() => { this.getSkills() })
    },
    triggerSkillsFileInput () {
      this.$refs.skillsFileInput.click()
    },
    uploadSkillsFile (event) {
      const file = event.target.files[0]
      if (file) {
        this.pendingFile = file
        this.selectedYear = new Date().getFullYear()
        this.showYearSelectDialog = true
        event.target.value = ''
      }
    },
    cancelYearSelect () {
      this.showYearSelectDialog = false
      this.pendingFile = null
    },
    confirmYearSelect () {
      if (!this.selectedYear || this.selectedYear < 2000 || this.selectedYear > new Date().getFullYear()) {
        return
      }
      this.showYearSelectDialog = false
      const file = this.pendingFile
      this.pendingFile = null
      if (file) {
        this.loadingSkills = true
        this.$store.dispatch('setSuccess', {
          successMsg: `Processing skills file "${file.name}" for year ${this.selectedYear}. This may take several minutes depending on file size. Please wait...`
        })
        const formData = new FormData()
        formData.append('file', file)
        formData.append('year', this.selectedYear)
        this.axios.post('/api/employee_skills/upload_skills', formData, {
          headers: {
            Authorization: 'Bearer ' + this.user.token,
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          const successMsg = `Successfully processed ${res.data.processed} records (skills and additional info).`
          this.$store.dispatch('setSuccess', {
            successMsg: successMsg
          })
          if (res.data.errors && res.data.errors.length) {
            console.warn('Skills upload errors:', res.data.errors)
            const errorExamples = res.data.errors.slice(0, 5).map(err => {
              return `Row ${err.row}: ${err.employee ? `"${err.employee}" - ` : ''}${err.skill || err.field ? `${err.skill || err.field} - ` : ''}${err.error}`
            }).join('\n')
            const errorMsg = `${res.data.errors.length} rows had errors. ${res.data.errors.length > 5 ? 'First 5 examples:\n' : 'Examples:\n'}${errorExamples}`
            this.$store.dispatch('setError', {
              errorMsg: errorMsg
            })
          }
          this.getSkills()
        }).catch(error => {
          this.$store.dispatch('setSuccess', { successMsg: '' })
          this.$store.dispatch('setError', {
            errorMsg: error.message + (error.response && error.response.data ? ' - ' + error.response.data.message : '')
          })
        }).finally(() => {
          this.loadingSkills = false
        })
      }
    },
    closeDialog () {
      if (this.isTextField && this.showEditDialog) {
        this.showEditDialog = false
        this.isTextField = false
        this.currentValueToEdit = {
          employeeId: null,
          employeeFullName: '',
          skillsId: null,
          subcategoryId: null,
          categoryId: null,
          subCategoryName: '',
          years: null,
          endYear: null,
          your_estimation: null,
          date_of_estimation: null,
          expertId: null,
          expert_full_name: '',
          expert_estimation: null,
          isPrimary: false,
          textValue: null
        }
        this.getSkills()
      } else {
        this.currentValueToEdit = {
          employeeId: null,
          employeeFullName: '',
          skillsId: null,
          subcategoryId: null,
          categoryId: null,
          subCategoryName: '',
          years: null,
          endYear: null,
          your_estimation: null,
          date_of_estimation: null,
          expertId: null,
          expert_full_name: '',
          expert_estimation: null,
          isPrimary: false,
          textValue: null
        }
        this.isTextField = false
        this.searchEmployee = ''
        this.showExpert = false
        this.showEditDialog = false
        this.showEnglishLevelEditDialog = false
      }
    }
  },
  filters: {
    dateFilter (val) {
      return val ? new Date(val).toISOString().substr(0, 10) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .data-table {
    &::v-deep {
      .v-data-table__divider {
        border-color: rgba(0, 0, 0, .12) !important;
      }
      tr {
        &:hover {
          td {
            //background: #eee !important;
            background: rgba(0, 155, 0, .12) !important;
          }
          // background: #eee !important;
          background: rgba(0, 155, 0, .12) !important;
        }
      }
      td.fixed-column {
        z-index: 1;
      }
      .fixed-column {
        position: sticky;
        left: 0;
        top: 0;
        z-index: 4;
        background-color: var(--v-background-base);
      }
    }
  }
  .editable-cell {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
</style>
